import axios from 'services/axios-interceptors';
import { API_PATH } from 'store/service';

export const projectStatusServices = {
  getProjectStatuses() {
    return axios.get(API_PATH + '/project/projectStatus/all');
  }
};
